import { Action } from '../../types/Action';
import {
  DigitalAudienceCustomBuilderFilters,
  DigitalAudienceCustomBuilderFiltersResponse,
  DigitalAudienceCustomBuilderSelectedFilters,
} from '../../types/digital-audience/DigitalAudienceCustomBuilder';

export enum DigitalAudienceAudienceBuilderActionsType {
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_FILTERS_RESPONSE = 'Set digital audience custom builder filters response',
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_FILTERS = 'Set digital audience custom builder filters',
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SELECTED_FILTERS = 'Set digital audience custom builder selected filters',
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_LOADING = 'Set digital audience custom builder is loading',
  RESET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SELECTED_FILTERS = 'Reset digital audience custom builder selected filters',
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_CURRENT_VEHICLE_OPTIONS_ACTIVE = 'Set digital audience custom builder is current vehicle options active',
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_REPLACEMENT_VEHICLE_OPTIONS_ACTIVE = 'Set digital audience custom builder is replacement vehicle options active',
  SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SIGNAL = 'Set digital audience custom builder signal',
  SET_DIGITAL_AUDIENCE_AUDIENCE_BUILDER_BLOCKED_MODAL = 'Set digital audience audience builder blocked modal',
}

export const setCustomBuilderFiltersResponse = (
  filtersResponse: DigitalAudienceCustomBuilderFiltersResponse,
): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_FILTERS_RESPONSE,
  payload: { filtersResponse: filtersResponse },
});

export const setCustomBuilderFilters = (filters: DigitalAudienceCustomBuilderFilters): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_FILTERS,
  payload: { filters: filters },
});

export const setCustomBuilderSelectedFilters = (
  filters: DigitalAudienceCustomBuilderSelectedFilters,
): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SELECTED_FILTERS,
  payload: { filters: filters },
});

export const setCustomBuilderIsLoading = (value: boolean): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_LOADING,
  payload: value,
});

export const resetCustomBuilderSelectedFilters = (): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.RESET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SELECTED_FILTERS,
});

export const setCustomBuilderCurrentVehicleOptionsActive = (value: boolean): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_CURRENT_VEHICLE_OPTIONS_ACTIVE,
  payload: value,
});

export const setCustomBuilderReplacementVehicleOptionsActive = (value: boolean): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_REPLACEMENT_VEHICLE_OPTIONS_ACTIVE,
  payload: value,
});

export const setCustomBuilderSignal = (value: boolean): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SIGNAL,
  payload: value,
});

export const setAudienceBuilderBlockedModalOpened = (value: boolean): Action => ({
  type: DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_AUDIENCE_BUILDER_BLOCKED_MODAL,
  payload: value,
});

export type DigitalAudienceCustomBuilderActions = ReturnType<
  | typeof setCustomBuilderFilters
  | typeof setCustomBuilderSelectedFilters
  | typeof setCustomBuilderIsLoading
  | typeof setCustomBuilderFiltersResponse
  | typeof resetCustomBuilderSelectedFilters
  | typeof setCustomBuilderCurrentVehicleOptionsActive
  | typeof setCustomBuilderReplacementVehicleOptionsActive
  | typeof setCustomBuilderSignal
  | typeof setAudienceBuilderBlockedModalOpened
>;
